import {Word} from "@game/word";
import {CSSProperties, useEffect, useState} from "react";
import {Bounds2} from "@utility/bounds2";
import {Vector2} from "@utility/vector2";
import {THEME, TILE_SIZE} from "@components/core/theme";
import {WordScore} from "@components/interface/WordScore";

export const BORDER_PADDING = TILE_SIZE.minus(6);
export const BORDER_OFFSET = new Vector2(1, 1);

const styles: Record<string, CSSProperties> = {
    ...THEME,
    content: {
        borderRadius: 4,
        borderStyle: "solid",
        borderWidth: 4,
        display: "flex",
        pointerEvents: "none",
        position: "absolute"
    }
};

interface IWordOutline {
    legal: boolean
    offset: Vector2
    scored: boolean
    word: Word
}
export function WordOutline({legal, offset, scored, word}: IWordOutline) {
    const [outline, setOutline] = useState<Bounds2>(Bounds2.zeroEmpty);
    const style: CSSProperties = {
        ...styles.content,
        borderColor: legal ? "green" : "red",
        flexDirection: word.from.position.x === word.to.position.x ? "column" : "row",
        left: outline.min.x - BORDER_OFFSET.x - 2,
        top: outline.min.y - BORDER_OFFSET.y - 2,
        height: outline.height(),
        width: outline.width()
    };

    useEffect(() => {
        setOutline(new Bounds2(word.from.position.multiply(TILE_SIZE),
            word.to.position.multiply(TILE_SIZE).plus(BORDER_PADDING)));
    }, [word]);
    return (
        <div style={style}>
            {scored && <WordScore word={word}/>}
        </div>
    );
}